const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-dark-200 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-dark-100 rounded-lg shadow-xl p-8">
          <h1 className="text-4xl font-bold text-white mb-6">Terms of Service</h1>
          <p className="text-gray-400 mb-8">Last Updated: October 24, 2025</p>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. Agreement to Terms</h2>
              <p className="mb-4">
                These Terms of Service ("Terms") constitute a legally binding agreement between you and S.C. STUDIO PLATFORMS S.R.L. ("Company," "we," "us," or "our"), a company registered in Romania with its registered office in Craiova, Romania, concerning your access to and use of the Studio Blockchain Explorer website and services (collectively, the "Service").
              </p>
              <p className="mb-4">
                By accessing or using the Service, you agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">2. Description of Service</h2>
              <p className="mb-4">
                Studio Blockchain Explorer is a blockchain explorer service that provides users with the ability to:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>View and search blockchain transactions, blocks, and addresses</li>
                <li>Access publicly available blockchain data from the Studio Blockchain network</li>
                <li>Analyze blockchain statistics and network information</li>
                <li>Utilize AI-powered visualization and analytics tools</li>
                <li>Access developer documentation and API services</li>
              </ul>
              <p className="mt-4">
                The Service is provided for informational purposes only and does not constitute financial, investment, or legal advice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. Eligibility</h2>
              <p className="mb-4">
                You must be at least 18 years old to use the Service. By using the Service, you represent and warrant that:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>You are at least 18 years of age</li>
                <li>You have the legal capacity to enter into these Terms</li>
                <li>You will comply with all applicable laws and regulations</li>
                <li>All information you provide is accurate and current</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. User Responsibilities</h2>
              <p className="mb-4">When using the Service, you agree to:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>Use the Service only for lawful purposes and in accordance with these Terms</li>
                <li>Not attempt to gain unauthorized access to any part of the Service</li>
                <li>Not interfere with or disrupt the Service or servers</li>
                <li>Not use automated systems (bots, scrapers) without our prior written consent</li>
                <li>Not transmit any malicious code, viruses, or harmful content</li>
                <li>Not impersonate any person or entity</li>
                <li>Not violate any applicable laws or regulations</li>
                <li>Not use the Service to engage in any fraudulent or illegal activities</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Intellectual Property Rights</h2>
              <p className="mb-4">
                The Service and its entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by the Company, its licensors, or other providers of such material and are protected by Romanian and international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.
              </p>
              <p className="mb-4">
                You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Service, except as follows:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Your computer may temporarily store copies of such materials in RAM incidental to your accessing and viewing those materials</li>
                <li>You may store files that are automatically cached by your web browser for display enhancement purposes</li>
                <li>You may print or download one copy of a reasonable number of pages of the Service for your own personal, non-commercial use</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">6. Blockchain Data</h2>
              <p className="mb-4">
                The Service displays publicly available blockchain data from the Studio Blockchain network. You acknowledge and agree that:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Blockchain data is public and immutable by nature</li>
                <li>We do not control or modify blockchain data</li>
                <li>We are not responsible for the accuracy or completeness of blockchain data</li>
                <li>Blockchain transactions are irreversible</li>
                <li>You are solely responsible for verifying any blockchain data before taking action based on it</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">7. API Usage</h2>
              <p className="mb-4">
                If you use our API services, you agree to:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Comply with any rate limits and usage restrictions</li>
                <li>Not abuse or overload our API infrastructure</li>
                <li>Properly attribute data obtained from our API</li>
                <li>Not resell or redistribute API data without authorization</li>
                <li>Maintain the security of any API keys or credentials</li>
              </ul>
              <p className="mt-4">
                We reserve the right to modify, suspend, or terminate API access at any time without notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">8. Disclaimer of Warranties</h2>
              <p className="mb-4">
                THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Warranties of merchantability, fitness for a particular purpose, or non-infringement</li>
                <li>Warranties that the Service will be uninterrupted, secure, or error-free</li>
                <li>Warranties regarding the accuracy, reliability, or completeness of any content</li>
                <li>Warranties that defects will be corrected</li>
              </ul>
              <p className="mt-4">
                We do not warrant that the Service will meet your requirements or that any errors in the Service will be corrected. You use the Service at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">9. Limitation of Liability</h2>
              <p className="mb-4">
                TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE COMPANY, ITS AFFILIATES, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Loss of profits, data, use, goodwill, or other intangible losses</li>
                <li>Damages resulting from unauthorized access to or use of our servers</li>
                <li>Damages resulting from any errors, mistakes, or inaccuracies of content</li>
                <li>Personal injury or property damage resulting from your use of the Service</li>
                <li>Any interruption or cessation of transmission to or from the Service</li>
              </ul>
              <p className="mt-4">
                OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATED TO THE SERVICE SHALL NOT EXCEED €100 (ONE HUNDRED EUROS).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">10. Indemnification</h2>
              <p className="mb-4">
                You agree to defend, indemnify, and hold harmless the Company, its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to:
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>Your violation of these Terms</li>
                <li>Your use of the Service</li>
                <li>Your violation of any third-party rights</li>
                <li>Any content you submit or transmit through the Service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">11. Privacy and Data Protection</h2>
              <p className="mb-4">
                Your use of the Service is also governed by our <a href="/privacy-policy" className="text-primary hover:text-primary-light">Privacy Policy</a> and <a href="/cookie-policy" className="text-primary hover:text-primary-light">Cookie Policy</a>. By using the Service, you consent to the collection, use, and disclosure of your information as described in those policies.
              </p>
              <p className="mb-4">
                We process personal data in accordance with the General Data Protection Regulation (GDPR) (EU) 2016/679 and Romanian Law 190/2018.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">12. Third-Party Links and Services</h2>
              <p className="mb-4">
                The Service may contain links to third-party websites or services that are not owned or controlled by the Company. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
              </p>
              <p className="mb-4">
                You acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such third-party websites or services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">13. Modifications to the Service</h2>
              <p className="mb-4">
                We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) at any time, with or without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">14. Changes to Terms</h2>
              <p className="mb-4">
                We may revise and update these Terms from time to time at our sole discretion. All changes are effective immediately when posted and apply to all access to and use of the Service thereafter.
              </p>
              <p className="mb-4">
                Your continued use of the Service following the posting of revised Terms means that you accept and agree to the changes. You are expected to check this page frequently so you are aware of any changes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">15. Termination</h2>
              <p className="mb-4">
                We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms.
              </p>
              <p className="mb-4">
                Upon termination, your right to use the Service will immediately cease. All provisions of these Terms which by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">16. Governing Law and Jurisdiction</h2>
              <p className="mb-4">
                These Terms shall be governed by and construed in accordance with the laws of Romania, without regard to its conflict of law provisions.
              </p>
              <p className="mb-4">
                Any disputes arising out of or relating to these Terms or the Service shall be subject to the exclusive jurisdiction of the courts of Craiova, Romania. However, we retain the right to bring legal proceedings in any jurisdiction where you reside or where a breach of these Terms occurs.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">17. Dispute Resolution</h2>
              <p className="mb-4">
                In the event of any dispute, controversy, or claim arising out of or relating to these Terms or the Service, the parties agree to first attempt to resolve the dispute through good faith negotiations.
              </p>
              <p className="mb-4">
                If the dispute cannot be resolved through negotiations within 30 days, either party may pursue legal remedies in accordance with Section 16 (Governing Law and Jurisdiction).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">18. Severability</h2>
              <p className="mb-4">
                If any provision of these Terms is held to be invalid, illegal, or unenforceable, the validity, legality, and enforceability of the remaining provisions shall not in any way be affected or impaired, and such provision shall be deemed modified to the minimum extent necessary to make such provision valid, legal, and enforceable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">19. Waiver</h2>
              <p className="mb-4">
                No waiver by the Company of any term or condition set forth in these Terms shall be deemed a further or continuing waiver of such term or condition or a waiver of any other term or condition, and any failure of the Company to assert a right or provision under these Terms shall not constitute a waiver of such right or provision.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">20. Entire Agreement</h2>
              <p className="mb-4">
                These Terms, together with our Privacy Policy and Cookie Policy, constitute the entire agreement between you and the Company regarding the Service and supersede all prior and contemporaneous understandings, agreements, representations, and warranties, both written and oral, regarding the Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">21. Contact Information</h2>
              <p className="mb-4">
                If you have any questions about these Terms, please contact us:
              </p>
              <div className="bg-dark-200 p-4 rounded-lg">
                <p className="mb-2"><strong className="text-white">Company Name:</strong> S.C. STUDIO PLATFORMS S.R.L.</p>
                <p className="mb-2"><strong className="text-white">Registered Office:</strong> Craiova, Romania</p>
                <p className="mb-2"><strong className="text-white">Email:</strong> office@studio-blockchain.com</p>
                <p className="mb-2"><strong className="text-white">Website:</strong> https://studioplatforms.eu</p>
              </div>
            </section>

            <section className="mt-8 pt-8 border-t border-gray-700">
              <p className="text-sm text-gray-400 italic">
                By using the Studio Blockchain Explorer, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
